export default __webpack_public_path__ + "static/media/ChallengeActive.0b1a7097.svg";